import { render, staticRenderFns } from "./GenerateExclusiveTicket.vue?vue&type=template&id=270bf6de&"
import script from "./GenerateExclusiveTicket.vue?vue&type=script&lang=ts&"
export * from "./GenerateExclusiveTicket.vue?vue&type=script&lang=ts&"
import style0 from "./GenerateExclusiveTicket.vue?vue&type=style&index=0&id=270bf6de&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports